import { Box, Button } from '@octanner/prism-core'
import { tannerGray } from '@octanner/prism-core/ThemeProvider/colors'
import React from 'react'

interface Props {
  loading: boolean
  isEditMode: boolean
  onSubmit: (e: React.SyntheticEvent) => void
  onCancel: (e: React.SyntheticEvent) => void
}

const ActionButtons = ({ loading, onSubmit, onCancel, isEditMode }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '8px',
        paddingBottom: '16px',
        borderBottom: `1px solid ${tannerGray[200]}`,
      }}
    >
      <Button
        data-testid="action-form:submit"
        onClick={onSubmit}
        loading={loading}
      >
        {`${isEditMode ? 'Update Action' : 'Add action'}`}
      </Button>
      <Button
        data-testid="action-form:cancel"
        color="secondary"
        onClick={onCancel}
        disabled={loading}
      >
        Cancel
      </Button>
    </Box>
  )
}

export default ActionButtons
